import Dynamic02 from './template_01';

const DefaultDynamic02=(props) =>{
    return (
        <Dynamic02 {...props}/>
    );
  }
  
  export default DefaultDynamic02;